module.exports = "/assets/data/7dc5882f819a545b4924cdfaf2adfd5c-KT2.data.json";